import React from 'react';
import { reduxWrapper } from '@common/redux/store';
import { NotFoundPage } from '@kursk/components/pages/404/NotFoundPage';
import { SingleArtefact } from "@kursk/components/pages/SingleArtefact/SingleArtefact";
import { loadArticle } from "@common/redux/slices/articles.slice";
import { loadRecommendationsForArticlesArtefacts } from "@common/redux/slices/recommendation.slice";

export default function page({ notFound }) {

  if (notFound) {
    return (<NotFoundPage/>);
  }
  return (
    <SingleArtefact/>
  );
}

export const getServerSideProps = reduxWrapper.getServerSideProps(async ({ store, params }) => {
  const { id } = params;
  await Promise.all([
    store.dispatch<any>(loadArticle({ _id: id })),
    store.dispatch<any>(loadRecommendationsForArticlesArtefacts({ _id: id }))
  ]);
  const { article } = store.getState().articleList;

  if (!article?._id) {
    return {
      props: { notFound: true }
    };
  }
});
